import React, { ComponentProps } from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from "react-to-webcomponent";
import { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";

import { TextElement } from "@ibinder/ui-common-core";
import { iBinderMainTheme } from "@ibinder/ui-common-styles";

interface TextElementProps extends ComponentProps<typeof TextElement> {
  text?: string;
}

const Index = ({ text, ...props }: TextElementProps) => {
  return (
    <ThemeProvider theme={iBinderMainTheme}>
      <TextElement {...props}>{text}</TextElement>
    </ThemeProvider>
  );
};

Index.propTypes = {
  fontStyle: PropTypes.string,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
  marginRight: PropTypes.string
};

customElements.define(
  "ibinder-text-element",
  // @ts-ignore
  reactToWebComponent(Index, React, ReactDOM)
);
